<template>
  <v-dialog
    v-model="dialog"
    width=" auto"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <alert-message></alert-message>
            <v-row>
              <v-col cols="12">
                <v-switch
                  label="All Day"
                  v-model="form.isAllDay"
                  dense
                  :hide-details="true"
                  :disabled="isDatetimeDisabled"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-row>
                  <v-col :cols="!form.isAllDay ? 6 : 12">
                    <date-picker
                      :disabled="isDatetimeDisabled"
                      v-model="form.startDate"
                      label="Start Date *"
                      :error-messages="[].concat(fieldErrors('form.startDate'))"
                      @blur="$v.form.startDate.$touch()"
                      :hide-details="true"
                    />
                  </v-col>
                  <v-col cols="6">
                    <div v-show="!form.isAllDay">
                      <time-picker
                        :disabled="isDatetimeDisabled"
                        v-model="form.startTime"
                        label="Time *"
                        :error-messages="
                          [].concat(fieldErrors('form.startTime'))
                        "
                        @blur="$v.form.startTime.$touch()"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <v-row>
                  <v-col :cols="!form.isAllDay ? 6 : 12">
                    <date-picker
                      :disabled="isDatetimeDisabled"
                      v-model="form.endedDate"
                      label="End Date *"
                      :error-messages="[].concat(fieldErrors('form.endedDate'))"
                      @blur="$v.form.endedDate.$touch()"
                      :hide-details="true"
                    />
                  </v-col>
                  <v-col cols="6">
                    <div v-show="!form.isAllDay">
                      <time-picker
                        :disabled="isDatetimeDisabled"
                        v-model="form.endedTime"
                        label="Time *"
                        :error-messages="
                          [].concat(fieldErrors('form.endedTime'))
                        "
                        @blur="$v.form.endedTime.$touch()"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row v-show="hasAccess('timeOff.view')">
              <v-col cols="12">
                <user-select
                  v-model="form.userId"
                  label="Employee"
                  :error-messages="[].concat(fieldErrors('form.userId'))"
                  @blur="$v.form.userId.$touch()"
                  :multiple="false"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="form.reason"
                  label="Reason"
                  :error-messages="[].concat(fieldErrors('form.reason'))"
                  @blur="$v.form.reason.$touch()"
                  rows="3"
                  auto-grow
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-switch
                  v-model="form.isPaidTime"
                  label="Paid Time"
                  :error-messages="[].concat(fieldErrors('form.isPaidTime'))"
                  @blur="$v.form.isPaidTime.$touch()"
                ></v-switch>
              </v-col>
            </v-row>

            

            <v-row v-show="isEdit">
              <v-col cols="12" sm="6">
                <h3>Superintendant Approval</h3>
                <v-row>
                  <v-col cols="12">
                    <v-select
                      v-model="form.approvalBySupervisor"
                      label="Status"
                      :error-messages="
                        [].concat(fieldErrors('form.approvalBySupervisor'))
                      "
                      @blur="$v.form.approvalBySupervisor.$touch()"
                      :items="statusItems"
                      :disabled="!isSuperintendent"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-textarea v-model="form.supervisorReason" rows="2" :disabled="!isSuperintendent" />
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="6">
                <h3>Field Manager Approval</h3>
                <v-row>
                  <v-col cols="12">
                    <v-select
                      v-model="form.approvalByFieldManager"
                      label="Status"
                      :error-messages="
                        [].concat(fieldErrors('form.approvalByFieldManager'))
                      "
                      @blur="$v.form.approvalByFieldManager.$touch()"
                      :items="statusItems"
                      :disabled="!isUserFieldManager"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-textarea v-model="form.fieldManagerReason" rows="2" :disabled="!isUserFieldManager" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn
            v-show="(isSuperAdmin || hasAccess('timeOff.delete')) && isEdit"
            color="error"
            @click="confirmDelete()"
          >
            Delete
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>

          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
          >
            {{ isEdit ? "Save" : "Submit" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import UTIL from "src/helpers/utility";
import { mapActions, mapState,mapGetters } from "vuex";
import AlertMessage from "src/components/AlertMessage";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import DatePicker from "src/components/DatePicker.vue";
import UserSelect from "src/components/UserSelect";
import formatterMixin from "@/mixins/formatterMixin";
import TimePicker from "components/TimePicker.vue";

const defaultInputs = {
  id: "",
  status: "requested",
  startDate: undefined,
  startTime: undefined,
  endedDate: undefined,
  endedTime: undefined,
  reason: "",
  clientId: "",
  isPaidTime: true,
  color: "#CFCFCF",
  dateCreated: null,
  lastUpdated: null,
  userId: "",

  isAllDay: true,

  // set default value
  approvalBySupervisor: "requested",
  supervisorReason: "",
  approvalByFieldManager: "requested",
  fieldManagerReason: "",
};

export default {
  components: {
    AlertMessage,
    DatePicker,
    UserSelect,
    TimePicker,
  },
  props: {
    clientId: Number,
    item: Object,
    show: [Boolean, String],
    title: String,
    isDraggable: Boolean
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      userId: {},

      status: {},
      code: {},
      type: {},
      startDate: { required },
      startTime: { required },
      endedTime: { required },
      endedDate: { required },
      clientId: {},
      reason: {},
      isPaidTime: {},
      approvalBySupervisor: {},
      supervisorReason: {},
      approvalByFieldManager: {},
      fieldManagerReason: {},
    },
  },
  validationMessages: {
    form: {
      userId: { required: "Required" },

      status: {
        required: "Required",
      },
      type: {
        required: "Required",
      },
      startDate: {
        required: "Required",
      },
      startTime: {
        required: "Required",
      },
      endedTime: {
        required: "Required",
      },
      endedDate: {
        required: "Required",
      },
      reason: {
        required: "Required",
      },
      clientId: {
        required: "Required",
      },
      isPaidTime: {},
      approvalBySupervisor: {},
      supervisorReason: {},
      approvalByFieldManager: {},
      fieldManagerReason: {},
    },
  },

  data() {
    return {
      showDialog: this.show,
      form: {
        ...defaultInputs,
      },
      dialog: false,
      valid: false,
      loading: false,
      showAttachFile: false,
      showJobDetail: false,
      materials: [],

      statusItems: [
        {
          text: "Requested",
          value: "requested",
        },
        {
          text: "Approved",
          value: "approved",
        },
        {
          text: "Denied",
          value: "denied",
        },
      ],
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },
  },

  computed: {
    ...mapGetters('account', ['hasAccess']),
    ...mapState({
      account: (state) => state.account,
      user: (state) => state.account.data.user,
      task: (state) => state.task,
      status: (state) => state.timeOff.status,
    }),
    formTitle() {
      return this.isEdit ? `Update Request Time Off` : `Request Time Off`;
    },
    isEdit() {
      return UTIL.gv(this.item, "id", "") ? true : false;
    },
    taskId() {
      return UTIL.gv(this.item, "id", "");
    },
    isDatetimeDisabled() {
      return false;
      // return !this.isDraggable;
    },
    isUserFieldManager() {
      return this.account.data.user.userGroupName == 'Field Manager' || this.account.data.user.userGroupName=='Super Admin';
    },
    isSuperintendent() {
      return this.account.data.user.userGroupName == 'Superintendant' || this.account.data.user.userGroupName=='Super Admin';
    },
    isSuperAdmin() {
      return this.account.data.user.userGroupName=='Super Admin';
    }
  },

  methods: {
    ...mapActions("timeOff", ["create", "update", "delete"]),

    async confirmDelete() {
      if (confirm("Are you sure will delete it?")) {
        await this.delete(this.item);
        if (!this.status.error) {
          this.refreshAndClose();
        }
      }
    },

    viewOrAddFile() {
      this.showAttachFile = true;
    },

    viewJobDetail() {
      this.showJobDetail = true;
      this.jobDetail = this.item;
    },

    clearJobDetail() {
      this.showJobDetail = false;
    },

    clearAttachFile() {
      this.showAttachFile = false;
    },

    refreshAndClose() {
      this.$emit("onSucceded");
      this.dialog = false;
    },

    initForm() {
      let fromStartDate =
        this.item && this.item.startDate ? this.item.startDate : new Date();
      let fromEndDate =
        this.item && this.item.endDate ? this.item.endDate : new Date();
      let startDate = this.momentLocal(fromStartDate).format("YYYY-MM-DD");
      let startTime = this.momentLocal(fromStartDate).format("HH:mm");
      let endedDate = this.momentLocal(fromEndDate).format("YYYY-MM-DD");
      let endedTime = this.momentLocal(fromEndDate).format("HH:mm");

      if (this.isEdit) {
        this.form = {
          ...this.form,
          ...this.item,
          clientId: this.clientId,
          startDate,
          startTime,
          endedDate,
          endedTime,
        };
      } else {
        this.form = {
          ...defaultInputs,
          clientId: this.clientId,
          userId: this.user.id, // set default user to current logged user when creating
          startDate,
          startTime,
          endedDate,
          endedTime,
        };
      }
    },

    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },

    onDialogOpen() {
      this.$store.dispatch("alert/clear");

      this.initForm();
    },

    addNew() {
      this.dialog = true;
      this.form = {
        ...defaultInputs,
      };
    },
    completed() {
      this.$emit("onSucceded");
    },
    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      if (this.form.isAllDay) {
        // force to set no time if isAllDay true
        this.form.startTime = "00:01";
        this.form.endedTime = "23:59";
      }

      let startDate = this.localToUtc(
        this.form.startDate + " " + this.form.startTime
      );
      let endDate = this.localToUtc(
        this.form.endedDate + " " + this.form.endedTime
      );

      let payload = {
        ...this.form,
        startDate,
        endDate,
      };

      delete payload.endedDate;
      delete payload.endedTime;
      delete payload.startTime;

      if (this.isEdit) {
        await this.update({
          ...payload,
          id: this.item.id,
        });
      } else {
        delete payload.id;
        await this.create(payload);
      }

      if (!this.status.error) {
        this.completed();
        this.dialog = false;
      }

      this.loading = false;
    },
  },
};
</script>